import { lazyLoad } from 'utils/loadable';

export const WorkOrderDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.WorkOrderDetailsPage,
);
